// extracted by mini-css-extract-plugin
export var icon = "style-module--icon--5157c";
export var label = "style-module--label--cce07";
export var name = "style-module--name--7a370";
export var oekoIcon = "style-module--oekoIcon--4c836";
export var save = "style-module--save--d677e";